import { Dropdown } from 'approot/shared/dropdown/dropdown';
import { DropdownItem } from 'approot/shared/dropdown/dropdown-item.style';

type Props = {
  dropdownOptions: {
    text: string;
    onClick: () => void;
  }[];
};

const ContentPageActionDropdown = ({ dropdownOptions }: Props) => {
  if (dropdownOptions.length === 0) return null;

  return (
    <Dropdown
      buttonElement="Download"
      borderRadius={8}
      aria-label="Download options"
      data-selector="action-button"
      placement="bottom-end"
      dropdownContents={dropdownOptions.map((d, i) => (
        <DropdownItem key={i} onClick={d.onClick}>
          {d.text}
        </DropdownItem>
      ))}
    />
  );
};

export default ContentPageActionDropdown;
